import { useAuth } from "../providers/AuthProvider";

export default function RouteWrapper({ loggedComponent, defaultComponent, isPrivate }) {

    const { user } = useAuth();

    if (user && !isPrivate) {

        return loggedComponent;

    } else if (!user && isPrivate) {


        return defaultComponent;

    } else {

        return user ? loggedComponent : defaultComponent;

    };
};